import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';
import { EquipmentTemplateRuleEditComponent } from './EquipmentTemplateRuleEdit.component';


@Component({
  selector: 'my-equipment-template-rule-grid',
  templateUrl: './EquipmentTemplateRuleGrid.component.html'
})
export class EquipmentTemplateRuleGridComponent implements OnInit {

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(EquipmentTemplateRuleEditComponent) public equipmentTemplateRuleEditComponent: EquipmentTemplateRuleEditComponent;
    editedRecord: ent.EquipmentTemplateRule = {};
    records: ent.EquipmentTemplateRule[];
    cols: any[];

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService, 
        private router: Router, private exportService: serv.ExportService) 
    { 
      

    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        this.loadColumns();
        this.equipmentTemplateRuleEditComponent.requestTypeDropdownComponent.load();
        this.equipmentTemplateRuleEditComponent.activityReasonDropdownComponent.load();
        this.equipmentTemplateRuleEditComponent.equipmentClassDropdownComponent.load();
        this.equipmentTemplateRuleEditComponent.equipmentLineItemTypeDropdownComponent.load();
        this.equipmentTemplateRuleEditComponent.exportFileDropdownComponent.load();
        this.onSearchClick(null);
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'ShortDescription', header: 'Short Description' },
            { field: 'Description', header: 'Description' },
            { field: 'NotificationType', header: 'Notification Type' },
            { field: 'CodingA', header: 'CodingA' },
            { field: 'CodingB', header: 'CodingB' },
            { field: 'SpecialEvent', header: 'Special Event' },
            { field: 'SerializedAsset', header: 'Serialized Asset' },
            { field: 'ActivityReasonID', header: 'ActivityReasonID' },
            { field: 'ActivityReason.Code', header: 'Activity Reason Code' },
            { field: 'ActivityReason.Name', header: 'Activity Reason Name' },
            { field: 'EquipmentClass.Name', header: 'Equipment Class Name' },
            { field: 'EquipmentLineItemType.Name', header: 'Equipment Line Item Type Name' },
            { field: 'ExportFileID', header: 'Export File ID' },
            { field: 'ExportFile.Name', header: 'Export File Name' },
            { field: 'RequestTypeID', header: 'Request Type ID' },
            { field: 'RequestType.Name', header: 'Request Type Name' }
        ];

    }

    public onSearchClick(event: any){
        
        this.blockComponent.blocked = true;
        this.exportService.getEquipmentTemplateRules().subscribe(x=> {
            this.records = x;
            this.blockComponent.blocked = false;
        }, err=> {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }

    onAddClick(event: any){
        this.editedRecord = new ent.EquipmentTemplateRule();
        this.equipmentTemplateRuleEditComponent.requestTypeDropdownComponent.value = null;
        this.equipmentTemplateRuleEditComponent.activityReasonDropdownComponent.value = null;
        this.equipmentTemplateRuleEditComponent.equipmentClassDropdownComponent.value = null;
        this.equipmentTemplateRuleEditComponent.equipmentLineItemTypeDropdownComponent.value = null;
        this.equipmentTemplateRuleEditComponent.exportFileDropdownComponent.value = null;
        this.equipmentTemplateRuleEditComponent.displayDialog = true;
    }

    onEditClick(event: any, record: ent.ActivityReason){
        
        this.editedRecord = record;
        
        this.equipmentTemplateRuleEditComponent.requestTypeDropdownComponent.value = this.editedRecord.RequestTypeID;
        this.equipmentTemplateRuleEditComponent.activityReasonDropdownComponent.value = this.editedRecord.ActivityReasonID;
        this.equipmentTemplateRuleEditComponent.equipmentClassDropdownComponent.value = this.editedRecord.EquipmentClassID;
        this.equipmentTemplateRuleEditComponent.equipmentLineItemTypeDropdownComponent.value = this.editedRecord.EquipmentLineItemTypeID;
        this.equipmentTemplateRuleEditComponent.exportFileDropdownComponent.value = this.editedRecord.ExportFileID;
        this.equipmentTemplateRuleEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        var request: ent.SaveEquipmentTemplateRuleRequest = {EquipmentTemplateRule: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
        this.exportService.saveEquipmentTemplateRule(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }

    
    
}